import * as S from "./MoreNavItem.styles";
import { ReactComponent as IconMenu01 } from "../../../styles/assets/svg/icon-more-Loudspeaker.svg";
import { ReactComponent as IconMenu02 } from "../../../styles/assets/svg/icon-more-record.svg";
import { ReactComponent as IconMenu04 } from "../../../styles/assets/svg/icon-more-bus.svg";
import { ReactComponent as IconMenu06 } from "../../../styles/assets/svg/icon-more-alarm.svg";
import { ReactComponent as IconMenu07 } from "../../../styles/assets/svg/icon-more-Policy.svg";
import { ReactComponent as IconArrow } from "../../../styles/assets/svg/icon-arrowRight.svg";
import { Link } from "react-router-dom";

interface NavItemProps {
  icon?: number;
  url?: string;
  onClick?: () => void;
  menuTitle: string;
}

export const navIcon = [
  {
    id: 1,
    icon: <IconMenu01 />,
  },
  {
    id: 2,
    icon: <IconMenu02 />,
  },
  {
    id: 3,
    icon: <IconMenu04 />,
  },
  {
    id: 4,
    icon: <IconMenu06 />,
  },
  {
    id: 5,
    icon: <IconMenu07 />,
  },
  {
    id: 6,
    icon: <IconMenu07 />,
  },
];

export const MoreNavItem = ({
  icon,
  url,
  menuTitle,
  onClick,
}: NavItemProps) => {
  return (
    <Link to={`${url}`} onClick={onClick}>
      <S.BottomNavItemBox>
        <S.BottomNavItem active={false}>
          {icon != null ? (
            <S.NavItemIcon>{navIcon[icon]?.icon}</S.NavItemIcon>
          ) : (
            <S.NavItemIcon />
          )}
          <S.NavItemTit>{menuTitle}</S.NavItemTit>
        </S.BottomNavItem>
        <IconArrow color="#454545" />
      </S.BottomNavItemBox>
    </Link>
  );
};
